<template>
  <div class="container">
    <div class="top-box">
      <img src="../../../static/images/index/bg2.png" class="bgImg" />
      <div>指定搭建商</div>
    </div>
    <van-search
      v-model="keyword"
      shape="round"
      placeholder="搜索搭建商名称"
      @search="onSearch"
      @input="onSearch"
    />
    <div class="list-box" v-if="list != null && list.length > 0">
      <div class="builder_item" v-for="(item, index) in list" :key="index">
        <div class="bi_top">
          <div class="coverImg">
            <van-image fit="contain" :src="item.Cover" alt="" />
          </div>
          <div>
            <div class="company">{{ item.CompanyName }}</div>
            <div class="bi_line">
              <span style="min-width: 40px">地址：</span>
              <div>{{ item.Address }}</div>
            </div>
            <div class="bi_line">
              <span>传真：</span>
              <div>{{ item.Fax ? item.Fax : "暂无" }}</div>
            </div>
            <div class="bi_line">
              <span>电话：</span>
              <div>{{ item.Tel ? item.Tel : "暂无" }}</div>
            </div>
            <div class="bi_line">
              <span>手机：</span>
              <div class="phoneBox">
                <div class="phone">
                  <div v-for="(pitem, pindex) in item.MobileList" :key="pindex">
                    <span style="margin-right: 6px">{{ pitem.Name }}</span>
                    <span>{{ pitem.Mobile }}</span>
                  </div>
                </div>
                <div
                  class="callTa"
                  @click.stop="callClick(item.Tel, item.MobileList)"
                >
                  联系TA
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="noDataBox" v-else>
      <span class="iconfont icon-kong"></span>
      <div>暂无搜索结果，更换关键词试试吧</div>
    </div>

    <!-- 拨打电话 -->
    <van-action-sheet v-model="show">
      <div class="callBox">
        <div class="callItem" v-for="(item, index) in mobileList" :key="index">
          <a :href="{ tel: `${item.Mobile}` }">
            <span v-if="item.Name" style="margin-right: 10px">{{
              item.Name
            }}</span>
            <span>{{ item.Mobile }}</span>
          </a>
        </div>
        <div class="line"></div>
        <div class="callItem cancel" @click="cancelCall">取消</div>
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
import { ActionSheet, Image, Search } from "vant";
import { getExhibitionBuilderList } from "@/api/index";
export default {
  name: "expoBuilder",
  components: {
    "van-action-sheet": ActionSheet,
    "van-image": Image,
    "van-search": Search,
  },
  data() {
    return {
      keyword: "",
      list: [],
      show: false,
      mobileList: [],
    };
  },
  methods: {
    //搜索
    onSearch() {
      this.getList();
    },
    onCancel() {},

    //取消电话
    cancelCall() {
      this.show = false;
    },

    //拨打电话
    callClick(tel, mlist) {
      this.show = true;
      this.mobileList = JSON.parse(JSON.stringify(mlist));
      this.mobileList.unshift({ Mobile: tel, Name: "" });
    },

    //获取酒店列表
    getList() {
      var that = this;
      getExhibitionBuilderList({
        Name: that.keyword,
      }).then((res) => {}, (err) => {
        that.list = err.List && err.List.length > 0 ? err.List : [];
      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style scoped lang="less">
.container {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 20px;
  /deep/.van-search__content {
    background-color: #f5f5f5;
  }
  .top-box {
    width: 375px;
    height: 103px;
    position: relative;
    div {
      position: absolute;
      z-index: 1;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #fff;
      font-size: 23px;
      font-weight: bold;
    }
  }

  .bgImg {
    width: 100%;
    height: 100%;
  }
}

.builder_item {
  margin-bottom: 10px;
  padding: 10px 10px 0px 10px;
  background-color: #fff;
  color: #666660;
  font-size: 12px;
}

.bi_top {
  display: flex;
  padding-bottom: 10px;
  .coverImg {
    .van-image {
      width: 68px;
      height: 68px;
      border: 1px solid #f5f5f5;
      border-radius: 2px;
      overflow: hidden;
      margin-right: 12px;
    }
  }
}

.bi_line {
  display: flex;
  margin-top: 8px;
}

.company {
  color: #333333;
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
}

.phoneBox {
  display: flex;
  position: relative;
}

.phone > div:not(:first-child) {
  margin-top: 5px;
}

.callTa {
  font-size: 11px;
  color: #d62f2f;
  text-decoration: underline;
  position: absolute;
  bottom: 0px;
  right: -50px;
}

.callBox {
  font-size: 17px;
  color: #000;
  .line {
    height: 8px;
    background: #f2f2f2;
  }
}

.callItem {
  height: 56px;
  line-height: 56px;
  text-align: center;
  &:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.03);
  }
  a {
    color: #000 !important;
  }
}
</style>
